import { useState } from "react";
// import { Link } from "react-router-dom";
import "./Contact.css";
function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch(
      "https://api.web3forms.com/submit",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },

        body: JSON.stringify({
          access_key: "cdfd2023-f3db-46b4-b9a7-a1410c603cf8",

          name: form.name,
          email: form.email,
          message: form.message,
        }),
      }
    );

    const result = await response.json();

    console.log(result);

    if (result.success) {

      alert("Message Sent Successfully");

      setForm({
        name: "",
        email: "",
        message: "",
      });

    } else {

      alert(result.message);

    }

  } catch (error) {

    console.log(error);

    alert("Network Error");

  }
};

  return (
    <div className="contact-page">

      {/* LEFT SIDE */}
      <div className="contact-info">
        <h2>Get In Touch</h2>
        <p>We are here to help you switch to solar energy 🌞</p>

        <div className="info-box">
          <p>📍Jhansi ,Uttar Pradesh (India)</p>
          <p>📞 +91 8953395689</p>
          <p>📧 solarwavetechnology@gmail.com</p>
        </div>
      </div>

      {/* RIGHT SIDE FORM */}
      <div className="contact-form">
        <h2>Send Message</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
          />

          <input
            type="email"
            placeholder="Your Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />

          <textarea
            placeholder="Your Message"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            required
          ></textarea>

          <button type="submit">Send Message 🚀</button>
        </form>
      </div>

    </div>
  );
}

export default Contact;